import KnowledgeBaseContainer from "../../components/miscellaneous/knowledgeBase";

const KnowledgeBase = () => {
  return <KnowledgeBaseContainer />;
};

export default KnowledgeBase;
